import { useCallback, useContext, useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import tableStatusIcon from 'assets/images/roompage-table-status.svg'
import tableCoinIcon from 'assets/images/coin.svg'
import { useAtom } from 'jotai'
import {
	roomListAtom,
	roomListFilteredAtom,
	roomSearchAtom,
} from 'config/store'
import JoinModal from 'components/Modal/JoinModal'
import { useQuery } from 'react-query'
import { getUserQuery } from 'dataLayer/user'
import { getUserinfo } from 'utils/localStorage'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { PATHS } from 'config/routes'
import { SocketContext } from 'utils/socket'
import {
	getListRoomOfGameQuery,
	getUserInfoQuery,
	useCreateRoomByPlayNowOfGame,
	useJoinRoomNowOfGame,
} from 'dataLayer/game'
import LoginWebModal from 'components/Modal/LoginWebModal'
import noDataIcon from 'assets/images/profilepage-gifthist-nodata.svg'
import { showSnackbar } from 'store/actions'
import { useDispatch } from 'react-redux'

function RoomTableMobile({ level }) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { roomId } = useParams()
	const dispatch = useDispatch()
	const DOMAIN_UID = process.env.REACT_APP_DOMAIN_UID
	const CLIENTID = process.env.REACT_APP_CLIENTID
	const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
	// const [roomList] = useAtom(roomListAtom)
	const [roomListSearch] = useAtom(roomListFilteredAtom)
	const [roomSearch] = useAtom(roomSearchAtom)
	// const roomListFiltered = roomSearch.length === 0 ? roomList : roomListSearch
	const [limit, setLimit] = useState()
	const [pageIndex, setPageIndex] = useState()
	const [roomList, setRoomList] = useState([])
	const { socket, setSocketRoomId } = useContext(SocketContext)
	const [roomSelect, setRoomSelect] = useState({})

	const { data: user } = useQuery(getUserQuery())
	const { data, isLoading } = useQuery(
		getListRoomOfGameQuery(roomId, '', '', '', level),
	)
	useEffect(() => {
		if (data) {
			setRoomList(data?.rooms)
		}
	}, [data, level])
	const { data: userInfo } = useQuery(getUserInfoQuery())

	const [modalJoinGame, setModalJoinGame] = useState(false)
	const [modalShowLoginPass, setModalShowLoginPass] = useState(false)

	function openLoginModal() {
		// setModalShowLoginPass(true)
		window.location.href = `${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`
	}
	const handleDataJoinGame = useCallback(
		data => {
			if (roomSelect.coin <= userInfo.coin) {
				if (getUserinfo()) {
					setSocketRoomId(roomSelect.id)
					fnJoin({
						room_id: roomSelect.id,
						password: data,
					})
				} else {
					openLoginModal()
				}
			} else {
				dispatch(showSnackbar(true, t('room.table.check_coin'), 'error'))
				// alert(t('room.table.check_coin'))
			}
		},
		[roomSelect],
	)
	function openJoinModal(data) {
		if (getUserinfo()) {
			setRoomSelect(data)
			if (data.required_password) {
				setModalJoinGame(true)
			} else {
				if (data.coin <= userInfo.coin) {
					setSocketRoomId(data.id)
					fnJoin({
						room_id: data.id,
					})
				} else {
					dispatch(showSnackbar(true, t('room.table.check_coin'), 'error'))
					// alert(t('room.table.check_coin'))
				}
			}
		} else {
			openLoginModal()
		}
		// if (getUserinfo()) {
		// 	setModalJoinGame(true)
		// } else {
		// 	navigate(PATHS.LOGIN_PASS_MOBILE)
		// }
	}
	function closeJoinModal() {
		setModalJoinGame(false)
	}
	const _joinRoomNowSuccess = result => {
		if (result) {
			let data = result.data.joinRoom
			socket.emit('join room', { room_id: data.room_id })
			navigate(PATHS.ROOM_PAGE.replace(':roomId', data.game_id))
			// setSocketRoomId(data.room_id)
			// navigate(
			// 	PATHS.PLAYROOM_PAGE.replace(':roomId', data.game_id).replace(
			// 		':gameId',
			// 		data.room_id,
			// 	),
			// )
		}
		dispatch(showSnackbar(true, t('modal.success'), 'success'))
	}
	const _joinRoomNowError = data => {
		dispatch(showSnackbar(true, data.message || "Can't join room!", 'error'))
	}
	const { mutate: fnJoin } = useJoinRoomNowOfGame(
		_joinRoomNowSuccess,
		_joinRoomNowError,
	)

	// TODO: Implement infinity scroll
	let roomListMobile =
		roomSearch && roomSearch.length === 0 ? roomList : roomListSearch
	return (
		<>
			<Container fluid className="roompage-mobile-tab-container">
				<Row className="mt-3 gy-3 gx-3">
					{roomListMobile.length > 0 ? (
						roomListMobile.map(room => {
							return (
								<Col md={6} className="roompage-mobile-tabs">
									<Row className="align-items-center">
										<Col xs={10}>
											<div className="roompage-mobile-tab">
												<h2>{t('room.table.id')}:</h2>
												<p>{room?.id}</p>
											</div>
											<div className="roompage-mobile-tab mt-2">
												<h2>{t('room.table.player')}:</h2>
												<p>{room?.player_count}/2</p>
											</div>
											<div className="roompage-mobile-tab mt-2">
												<h2>{t('room.table.bet_level')}:</h2>
												<img src={tableCoinIcon} width="18" alt="Bet's coin" />
												<p>{new Intl.NumberFormat('lo').format(room?.coin)}</p>
											</div>
										</Col>
										<Col xs={2}>
											{room?.status === 2 ? (
												<img
													src={tableStatusIcon}
													width="40"
													className="room-status"
													alt="Room's status"
												/>
											) : null}
											{getUserinfo() ? (
												<Button
													disabled={room?.player_count === 1 ? false : true}
													onClick={() => openJoinModal(room)}
												>
													{t('room.table.join')}
												</Button>
											) : (
												<Button
													disabled={room?.player_count === 1 ? false : true}
												// onClick={() => openJoinModal(room)}
												>
													<Link
														style={{
															color: 'white',
															width: '100%',
															display: 'flex',
															justifyContent: 'center',
														}}
														to={`${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`}
													>
														{t('room.table.join')}
													</Link>
												</Button>
											)}
										</Col>
									</Row>
								</Col>
							)
						})
					) : (
						<img
							style={{ width: '50%', margin: 'auto', minHeight: '300px' }}
							src={noDataIcon}
							alt="No reward is found"
						/>
					)}
				</Row>
			</Container>
			{user ? (
				<JoinModal
					handleDataJoinGame={handleDataJoinGame}
					show={modalJoinGame}
					onHide={closeJoinModal}
				/>
			) : // : modalShowLoginPass ? (
				// 	<LoginWebModal
				// 		modalShowLoginPass={modalShowLoginPass}
				// 		setModalShowLoginPass={setModalShowLoginPass}
				// 	/>
				// )
				null}
		</>
	)
}

export default RoomTableMobile
